import { LayersApiService } from 'src/app/model/api-services/layers-api.service';
import { MapComponent } from 'src/app/components/map/map.component';
import { GeoLoc, LocationDialogView } from 'src/app/types/@types/sl-v-types';
// @ts-ignore
import { LngLatBounds, LngLat } from '!mapbox-gl';
import { MapPosition } from 'src/app/types/mapposition';
import { ViewContext } from 'src/app/types/view-context';
import { NavEvents, NavEvent } from '../NavEvents';
import { ImageCapturePanelComponent } from 'src/app/components/image-capture-panel/image-capture-panel.component';
import { SLLayer } from '../sl-layer';
import { SLContext } from 'src/app/types/sl-context';
import { ActionMap } from 'src/app/services/action-handler.service';
import { SLViewerComponent } from 'src/app/mapps/sl-viewer/sl-viewer.component';
import * as mapboxgl from 'mapbox-gl';
import { style } from 'd3';
import { iif } from 'rxjs';
import { SLMap } from '../sl-map';
import { FitSet } from '../api-services/layers-api.service';
import { ScaleService } from 'src/app/services/scale.service';
import { DisplayAction } from './display-actions';
import { PixoSpatial, PixoSpatialCoord } from '../Pixospatial';
import { MapTaskSequencer } from '../map-task-sequencer';



export class NavigationAction {
  public static geoWatcher = -1;
  public static Exec(command: string, map: MapComponent, data?: any) {

    switch (command) {
      case 'home':
        NavigationAction.Home(map);
        break;
      case 'reorient':
        NavigationAction.Reorient(map);
        break;
      case 'bearing-update':
        NavigationAction.BearingUpdate(map);
        break;
      case 'jump-to-loc':
        NavigationAction.JumpToLoc(map, data);
        break;
      case 'jump-to-geoloc':
        NavigationAction.JumpToGeoLoc(map, data);
        break;
      case 'history-back':
        NavigationAction.HistoryBack(map);
        break;
      case 'history-next':
        NavigationAction.HistoryNext(map);
        break;
      case 'history-first':
        NavigationAction.HistoryFirst(map);
        break;
      case 'history-last':
        NavigationAction.HistoryLast(map);
        break;
      case 'history-update-buttons':
        NavigationAction.UpdateHistoryButtons(map);
        break;
      case 'zoom-to':
        NavigationAction.ZoomTo(map, data?.zoom);
      case 'zoom-in':
        NavigationAction.ZoomIn(map);
        break;
      case 'zoom-out':
        NavigationAction.ZoomOut(map);
        break;
      case 'pitch-inc':
        NavigationAction.PitchInc(map);
        break;
      case 'pitch-dec':
        NavigationAction.PitchDec(map);
        break;
      case 'rotate-left':
        NavigationAction.RotateLeft(map);
        break;
      case 'rotate-right':
        NavigationAction.RotateRight(map);
        break;
      case 'gps-center':
        NavigationAction.GpsCenter(map);
        break;
      case 'gps-auto-orient':
        NavigationAction.GpsAutoOrient(map);
        break;
      case 'fit-extents':
        NavigationAction.Fit(map, data as FitSet[]);
        break;

    }
  }
  public static RegisterActions(actions): ActionMap {
    actions['navigation/home'] = {
      name: 'Return to initial (home) extent.',
      handler: (context: SLContext, ..._args: any) => {
        if (!!context.map) {
          NavigationAction.Home(context.map.component);
        }
      },
      keys: {
        key: 'h',
        ctrl: true
      },
      trigger: 'press'
    }
    actions['navigation/reorient'] = {
      name: 'Reorient to North',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.Reorient(context.map.component);
      },
      keys: {
        key: 'n',
      },
      trigger: 'press'
    }
    actions['navigation/pan-north'] = {
      name: 'Pan North',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.PanNorth(context.map.component);
      },
      keys: {
        key: 'ArrowDown'
      },
      trigger: 'press'
    }
    actions['navigation/pan-south'] = {
      name: 'Pan South',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.PanSouth(context.map.component);
      },
      keys: {
        key: 'ArrowUp'
      },
      trigger: 'press'
    }
    actions['navigation/pan-east'] = {
      name: 'Pan East',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.PanEast(context.map.component);
      },
      keys: {
        key: 'ArrowRight'
      },
      trigger: 'press'
    }
    actions['navigation/pan-west'] = {
      name: 'Pan West',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.PanWest(context.map.component);
      },
      keys: {
        key: 'ArrowLeft'
      },
      trigger: 'press'
    }
    actions['navigation/scale-zoom'] = {
      name: 'Stretch Map',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.ScaleZoom(context.map.component);
      },
      keys: {
        key: 'ArrowUp',
        ctrl: true,
        alt: true
      },
      trigger: 'press'
    }
    actions['navigation/un-scale-zoom'] = {
      name: 'Stretch Map',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.UnScaleZoom(context.map.component);
      },
      keys: {
        key: 'ArrowDown',
        ctrl: true,
        alt: true

      },
      trigger: 'press'
    }
    actions['navigation/zoom-in'] = {
      name: 'Zoom In',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.ZoomIn(context.map.component);
      },
      keys: {
        key: 'z',
      },
      trigger: 'press'
    }
    actions['navigation/zoom-out'] = {
      name: 'Zoom Out',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.ZoomOut(context.map.component);
      },
      keys: {
        key: 'z',
        shift: true
      },
      trigger: 'press'
    }
    actions['navigation/pitch-increase'] = {
      name: 'Pitch Increase',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.PitchInc(context.map.component);
      },
      keys: {
        key: 'ArrowUp',
        shift: true
      },
      trigger: 'press'
    }
    actions['navigation/pitch-decrease'] = {
      name: 'Pitch Decrease',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.PitchDec(context.map.component);
      },
      keys: {
        key: 'ArrowDown',
        shift: true
      },
      trigger: 'press'
    }
    actions['navigation/rotate-right'] = {
      name: 'Rotate Right',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.RotateRight(context.map.component);
      },
      keys: {
        key: 'ArrowRight',
        shift: true
      },
      trigger: 'press'
    }
    actions['navigation/rotate-left'] = {
      name: 'Rotate Left',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.RotateLeft(context.map.component);
      },
      keys: {
        key: 'ArrowLeft',
        shift: true
      },
      trigger: 'press'
    }
    actions['navigation/history-next'] = {
      name: 'Nav History - Next',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.HistoryNext(context.map.component);
      },
      keys: {
        key: '+',
      },
      trigger: 'press'
    }
    actions['navigation/history-back'] = {
      name: 'Nav History - Previous',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.HistoryBack(context.map.component);
      },
      keys: {
        key: '-',
      },
      trigger: 'press'
    }
    actions['navigation/history-last'] = {
      name: 'Nav History - Most recent entry',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.HistoryLast(context.map.component);
      },
      keys: {
        key: '+',
        shift: true
      },
      trigger: 'press'
    }
    actions['navigation/history-first'] = {
      name: 'Nav History - Oldest entry',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.HistoryFirst(context.map.component);
      },
      keys: {
        key: '-',
        shift: true
      },
      trigger: 'press'
    }
    actions['navigation/jump-to-loc'] = {
      name: 'Jump to location ...',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.JumpToLoc(context.map.component);
      },
      keys: {
        key: 'l',
      },
      trigger: 'press'
    }
    actions['navigation/gps-center'] = {
      name: 'Center Map via GPS',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.GpsCenter(context.map.component);
      },
      keys: {
        ctrl: true,
        key: 'g',
      },
      trigger: 'press'
    }
    actions['navigation/gps-auto-orient'] = {
      name: 'Start/Stop auto orienting map untilmap via GPS',
      handler: (context: SLContext, ..._args: any) => {
        NavigationAction.GpsAutoOrient(context.map.component);
      },
      keys: {
        alt: true,
        ctrl: true,
        key: 'g',
      },
      trigger: 'press'
    }
    actions['navigation/focus-map'] = {
      name: 'Focus on the map',
      handler: (context: SLContext, ..._args: any) => {
        context.map.ui.getCanvas().focus();
      },
      keys: {
        alt: true,
        ctrl: true,
        key: 'f',
      },
      trigger: 'press'
    }
    return actions;

  }


  public static Home(map: MapComponent) {
    map.SLMap.historyNaving = false;
    const event: NavEvent = NavEvents.New('navigation/home');
    map.SLMap.ui.fitBounds(map.home.bounds, { animate: false }, event);
    map.SLMap.ui.setBearing(0, event);
    map.SLMap.ui.setPitch(0, event);
  }
  public static Reorient(map: MapComponent) {
    const event: NavEvent = NavEvents.New('navigation/reorient');
    map.SLMap.ui.setBearing(0, event);
    map.SLMap.ui.setPitch(0, event);
    NavigationAction.UpdateIsNorth(map);
  }
  public static JumpToLoc(map: MapComponent, data?: GeoLoc) {
    map.locationService.RequestLocation((result: any) => {
      result.data.autoQuery = !!data?.autoQuery;
      this.JumpToGeoLoc(map, result.data as GeoLoc);
    }, 'search', map.SLMap);
  }
  public static JumpToGeoLoc(map: MapComponent, loc?: GeoLoc) {
    if (!loc) return;
    const event: NavEvent = NavEvents.New('navigation/jump-to-loc');
    let pt: PixoSpatialCoord;
    if (loc.bbox) {
      const bounds = new LngLatBounds(new LngLat(loc.bbox[0], loc.bbox[1]), new LngLat(loc.bbox[2], loc.bbox[3]));
      map.SLMap.ui.fitBounds(bounds, { animate: false }, event);
      map.SLMap.ui.jumpTo({ center: loc.point, bearing: 0, pitch: 0 }, event);
      pt = map.spatialContext.PixoSpatialCoord(map.spatialContext.SpatialCoord(loc.point));
    } else {
      const params: any = { center: loc.point, bearing: 0, pitch: 0 };
      if (loc.zoom !== undefined) {
        params.zoom = loc.zoom;
      } else {
        params.zoom = Math.max(map.SLMap.ui.getZoom(), SLMap.POINT_ZOOM)
      }
      map.SLMap.ui.jumpTo(params, event);
      if (loc.autoQuery !== false) loc.autoQuery = !!loc.point;
      if (!loc.autoQuery) {
        pt = map.spatialContext.PixoSpatialCoord(map.spatialContext.SpatialCoord(loc.point));
      }
    }
    if (!!pt) {
      const simClick = { lngLat: new LngLat(pt.spatial.lng, pt.spatial.lat), point: { x: pt.pixo.x, y: pt.pixo.y }, queryVis: true };
      // map.SetMarker(simClick);
      // map.InfoClick(simClick, true)

    }
  }
  public static HistoryBack(map: MapComponent) {

    const event: NavEvent = NavEvents.NewHistorical('navigation/history-back');
    map.SLMap.history.Prev(event);
  }
  public static HistoryNext(map: MapComponent) {

    const event: NavEvent = NavEvents.NewHistorical('navigation/history-back');
    map.SLMap.history.Next(event);

  }

  public static HistoryFirst(map: MapComponent) {
    const event: NavEvent = NavEvents.NewHistorical('navigation/history-first');
    map.SLMap.history.GoToFirst(event);
  }

  public static HistoryLast(map: MapComponent) {

    const event: NavEvent = NavEvents.NewHistorical('navigation/history-first');
    map.SLMap.history.GoToLast(event);

  }

  public static PitchInc(map: MapComponent) {
    const startPitch = map.SLMap.ui.getPitch();
    let pitch = startPitch + 5;

    if (pitch >= 60) {
      pitch = 60;
    }
    if (pitch !== startPitch) {
      const event: NavEvent = NavEvents.New('navigation/pitch-inc');
      map.SLMap.ui.setPitch(pitch, event);
    }
    NavigationAction.UpdateIsNorth(map);
  }
  public static ZoomTo(map: MapComponent, zoomLevel: number) {
    if (!isNaN(Number(zoomLevel))) {
      map.SLMap.ui.setZoom(zoomLevel);
    }
  }
  public static ZoomIn(map: MapComponent) {
    map.SLMap.ui.zoomIn();
  }
  public static ZoomOut(map: MapComponent) {
    map.SLMap.ui.zoomOut();
    /*const pitch = map.SLMap.ui.getPitch();
      if(pitch > 45) {
      const co = map.SLMap.ui.getFreeCameraOptions();
      const position = map.SLMap.ui.getCenter();
      const elevation = Math.floor(
        // Do not use terrain exaggeration to get actual meter values
        map.SLMap.ui.queryTerrainElevation(position, { exaggerated: false })
      );

      co.position = mapboxgl.MercatorCoordinate.fromLngLat(position,elevation+100);
      map.SLMap.ui.setFreeCameraOptions(co);
      map.SLMap.ui.setPitch(pitch);
    } else {*/

  }
  public static PitchDec(map: MapComponent) {
    let decPitch = map.SLMap.ui.getPitch();
    decPitch -= 5;
    if (decPitch <= 0) {
      decPitch = 0;
    }
    if (map.SLMap.ui.getPitch() !== decPitch) {
      const event: NavEvent = NavEvents.New('navigation/pitch-dec');
      map.SLMap.ui.setPitch(decPitch, event);
    }
    NavigationAction.UpdateIsNorth(map);

  }
  public static RotateLeft(map: MapComponent) {
    let leftAngle = map.SLMap.ui.getBearing();
    leftAngle += 10;
    const event: NavEvent = NavEvents.New('navigation/rotate-left');
    map.SLMap.ui.setBearing(leftAngle, event);
    this.BearingUpdate(map);
  }
  public static RotateRight(map: MapComponent) {
    let rightAngle = map.SLMap.ui.getBearing();
    rightAngle -= 10;
    const event: NavEvent = NavEvents.New('navigation/rotate-right');
    map.SLMap.ui.setBearing(rightAngle, event);
    this.BearingUpdate(map);
  }
  public static BearingUpdate(map: MapComponent) {
    if (!map.SLMap.ui) return;
    const angle = map.SLMap.ui.getBearing();
    const buttons: Array<HTMLButtonElement> = map.SLMap.src.GetActionButtons('"Go to"');
    for (const button of buttons) {
      if (!!map.SLMap.src.HandleBearing) {
        map.SLMap.src.HandleBearing(angle);
      } else {
        if (button.title.toLowerCase() === 'reset pitch and angle') {
          const element: HTMLElement = $('.fa-location-arrow', button)[0] as HTMLElement;
          element.style.transform = 'rotate(' + (-angle - 45) + 'deg)';
          break;
        }
      }
    }
    NavigationAction.UpdateIsNorth(map);

  }
  public static UpdateIsNorth(map: MapComponent) {
    const wasNorth = (map.SLMap.src.imageCaptureView as ImageCapturePanelComponent).mapIsOrientedNorth;
    const bearing = map.SLMap.ui.getBearing();
    const pitch = map.SLMap.ui.getPitch();
    if (!!map.SLMap.src.HandleBearing) {
      map.SLMap.src.HandleBearing(bearing);
    }
    if (!!map.SLMap.src.HandlePitch) {
      map.SLMap.src.HandlePitch(pitch);
    }
    (map.SLMap.src.imageCaptureView as ImageCapturePanelComponent).mapIsOrientedNorth = (bearing + pitch === 0);


  }
  public static GpsCenter(map: MapComponent) {
    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition((info) => {
        const event: NavEvent = NavEvents.New('navigation/gps-center');
        map.SLMap.ui.setCenter(new LngLat(info.coords.longitude, info.coords.latitude), event);
        map.SLMap.ui.setZoom(19, event);
      }, () => { }, { enableHighAccuracy: true, timeout: 250 });
    }
  }
  public static GpsAutoOrient(map: MapComponent) {
    if (NavigationAction.geoWatcher !== -1) {
      navigator.geolocation.clearWatch(NavigationAction.geoWatcher);
      NavigationAction.geoWatcher = -1;
      map.SLMap.src.StopGPS();
      return;
    }
    map.SLMap.src.StartGPS();
    NavigationAction.geoWatcher = navigator.geolocation.watchPosition((info) => {
      this.GPSAutoOrientAction(map, info);
    }, (error) => {
      switch (error.code) {
        case error.PERMISSION_DENIED:
        case error.POSITION_UNAVAILABLE:
        case error.TIMEOUT:
          break;

      }
    });
  }

  public static GPSAutoOrientAction(map: MapComponent, info: any) {
    if (NavigationAction.geoWatcher === -1) { return; }
    map.SLMap.historyNaving = false;
    const event: NavEvent = NavEvents.New('navigation/gps-auto-orient');
    map.SLMap.ui.setCenter(new LngLat(info.coords.longitude, info.coords.latitude), event);
    map.SLMap.ui.setZoom(19, event);
    if (info.coords.heading) {
      map.SLMap.ui.setBearing(info.coords.heading, event);
    }
    map.SLMap.src.GPSUpdate(info.coords, event);


  }
  public static UpdateHistoryButtons(map: MapComponent) {
    const buttons: Array<HTMLButtonElement> = map.SLMap.src.GetActionButtons('History');

    for (const button of buttons) {
      if (button.title === 'Previous') {
        button.disabled = !map.SLMap.history.HasPrev();
      }
      if (button.title === 'Next') {
        button.disabled = !map.SLMap.history.HasNext();
      }
    }
  }

  public static SetupButtons(map: MapComponent) {


  }
  // pixels the map pans when the up or down arrow is clicked
  static deltaDistance = 100;

  // degrees the map rotates when the left or right arrow is clicked
  static deltaDegrees = 25;

  static easing(t) {
    return t * (2 - t);
  }
  public static PanNorth(map: MapComponent) {
    if (map.SLMap.ui.getPitch() > 45) {
      map.SLMap.ui.setZoom(map.SLMap.ui.getZoom() - 1);
      return;
    }
    map.SLMap.ui.panBy([0, NavigationAction.deltaDistance]);
  }
  public static PanSouth(map: MapComponent) {
    if (map.SLMap.ui.getPitch() > 45) {
      map.SLMap.ui.setZoom(map.SLMap.ui.getZoom() + 1);
      return;
    }

    map.SLMap.ui.panBy([0, -NavigationAction.deltaDistance]);
  }
  public static PanEast(map: MapComponent) {
    map.SLMap.ui.panBy([NavigationAction.deltaDistance, 0]);
  }
  public static PanWest(map: MapComponent) {
    map.SLMap.ui.panBy([-NavigationAction.deltaDistance, 0]);
  }

  public static SetDeviceScale(map: MapComponent) {
    const pixelDensity = window.devicePixelRatio || 1;
    const scaleTransform = 'scale(' + pixelDensity + ')';
    map.SLMap.ui.getCanvas().style.transform = scaleTransform;
    map.SLMap.digitizer.drawPane.domElement.style.setProperty('transform', scaleTransform);

  }
  public static SetScaleZoom(map: MapComponent, index: number) {
    const transform = map.SLMap.ui.getCanvas().style.transform;

    const transforms = ['scale(1)', 'scale(1.5)', 'scale(2)', 'scale(2.5)', 'scale(3)'];
    map.SLMap.ui.getCanvas().style.transform = transforms[index];
    map.SLMap.digitizer.drawPane.domElement.style.setProperty('transform', transforms[index]);


  }

  public static ScaleZoom(map: MapComponent) {
    const transform = map.SLMap.ui.getCanvas().style.transform;

    const transforms = ['scale(1)', 'scale(1.5)', 'scale(2)', 'scale(2.5)', 'scale(3)'];
    let index = transforms.indexOf(transform);
    if (index < 1) {
      index = 0;
    }
    if (index < 3) {
      map.SLMap.ui.getCanvas().style.transform = transforms[index + 1];
      map.SLMap.digitizer.drawPane.domElement.style.setProperty('transform', transforms[index + 1]);
    } else if (index === 3) {
      map.SLMap.ui.getCanvas().style.transform = transforms[0];
      map.SLMap.digitizer.drawPane.domElement.style.setProperty('transform', transforms[0]);

    }
  }
  public static UnScaleZoom(map: MapComponent) {
    const transform = map.SLMap.ui.getCanvas().style.transform;
    const transforms = ['scale(1)', 'scale(1.5)', 'scale(2)', 'scale(2.5)', 'scale(3)'];
    const index = transforms.indexOf(transform);

    if (index <= 0) {
      map.SLMap.ui.getCanvas().style.transform = transforms[3];
      map.SLMap.digitizer.drawPane.domElement.style.setProperty('transform', transforms[index + 1]);
    } else if (index <= 3) {
      map.SLMap.ui.getCanvas().style.transform = transforms[index - 1];
      map.SLMap.digitizer.drawPane.domElement.style.setProperty('transform', transforms[index + 1]);
    }
  }
  public static Fit(map: MapComponent, sets: Array<FitSet>) {
    if (!sets?.length || !sets[0].features?.length) return;
    // Uses 0 buffer for src geometry, relies on fitBounds padding as px buffer.
    map.layersAPI.GetFitExtents(sets, 0).then((response) => {
      if (response?.lng_lat_bounds) {
        const pitch = map.SLMap.ui.getPitch();
        const bearing = map.SLMap.ui.getBearing();

        // Temporarily reorient
        map.SLMap.ui.setPitch(0);
        map.SLMap.ui.setBearing(0);
        // Compute camera for bounds in north-up view
        const currentZoom = map.SLMap.ui.getZoom();
        const targetCam = map.SLMap.ui.cameraForBounds(response.lng_lat_bounds, { padding: 48 });
        const cam = map.SLMap.ui.cameraForBounds(response.lng_lat_bounds, { padding: 48 });
        if (cam?.zoom !== undefined && targetCam.zoom - currentZoom >= 1) {
          // Clear layers before jump to avoid blurry artifact
          for (const layer of map.SLMap.layers) {
            layer.Clear();
          }

        }
        map.SLMap.ui.fitBounds(response.lng_lat_bounds, { animate: false, padding: 48 });
        map.SLMap.ui.setPadding(0);
        map.SLMap.ui.setPitch(pitch);
        map.SLMap.ui.setBearing(bearing);

      }
    });
  }
  /*public static Fit(map: MapComponent, sets: Array<FitSet>) {
    console.log(sets);
    if (!sets) return;

    if (sets.length === 0) return;
    if (sets[0].features.length === 0) return;
    map.layersAPI.GetFitExtents(sets, ScaleService.GetBufferFromPxDistance(32)).then((response) => {
      NavigationAction.Reorient(map);
      if (!!response.lng_lat_bounds) {
        // const bounds:LngLatBounds = new LngLatBounds(response.lng_lat_bounds);
        (map.SLMap.ui as mapboxgl.Map).fitBounds(response.lng_lat_bounds, { animate: false, padding: 32 });
        map.SLMap.ui.setPadding(0);
      }
    });
  }
    */

}
